import { Install_Codes } from "@/api/hasura/generated/graphql"
import { IInstallCode } from "@/models/installCode/installCode.types"
import {
  FilterCheckbox,
  FilterDateRange,
  FilterRadio,
  FilterType,
  SoDataTableColumnType,
  SoDataTableHeader,
} from "@/types/components/SoDataTable"
import { SoRadioCardChartType } from "@/types/components/SoRadioCardChart"

export type TableFilters = {
  comment: FilterRadio
  status: FilterCheckbox
  asnDate: FilterDateRange
  createdAt: FilterDateRange
  lastDateChecked: FilterDateRange
  requestedDate: FilterDateRange
}

export const headers: SoDataTableHeader<
  keyof IInstallCode,
  keyof Install_Codes
>[] = [
  {
    title: "Id",
    key: "id",
    isVisible: false,
  },
  {
    title: "MPXN",
    key: "mpxn",
    sortable: false,
  },
  {
    title: "MSN",
    key: "msn",
    sortKey: "msn",
  },
  {
    title: "Install Code",
    key: "installCode",
    sortKey: "install_code",
  },
  {
    title: "Device ID",
    key: "deviceId",
    sortKey: "device_id",
  },
  {
    title: "Map ID",
    key: "mapId",
    isVisible: false,
  },
  {
    title: "Map Name",
    key: "mapName",
    isVisible: false,
  },
  {
    title: "ASN Date",
    key: "asnDate",
    type: SoDataTableColumnType.DATE,
    isVisible: false,
  },
  {
    title: "ASN Status",
    key: "asnOutcome",
    sortKey: "asn_outcome",
  },
  {
    title: "Last Date Checked",
    key: "lastDateChecked",
    type: SoDataTableColumnType.DATE,
    sortKey: "last_date_checked",
  },
  {
    title: "Comments",
    key: "comment",
    sortable: false,
  },
  {
    title: "Created At",
    key: "createdAt",
    type: SoDataTableColumnType.DATE_TIME,
    isVisible: false,
  },
  {
    title: "Updated At",
    key: "updatedAt",
    type: SoDataTableColumnType.DATE_TIME,
    isVisible: false,
  },
]

export enum EInstallCodeStatus {
  HAS_INSTALL_CODE = "hasInstallCode",
  MISSING_INSTALL_CODE = "missingInstallCode",
  MISSING_ASN = "missingAsn",
  EXPIRING_ASN = "expiringAsn",
}

export const tableFilters: TableFilters = {
  status: {
    type: FilterType.CHECKBOX,
    label: "Status",
    options: {
      [EInstallCodeStatus.HAS_INSTALL_CODE]: "Has Install codes",
      [EInstallCodeStatus.MISSING_INSTALL_CODE]: "Missing Install codes",
      [EInstallCodeStatus.MISSING_ASN]: "Missing ASNs",
      [EInstallCodeStatus.EXPIRING_ASN]: "Expiring ASNs",
    },
    value: [],
    expandable: true,
  },
  comment: {
    type: FilterType.RADIO,
    label: "Comment",
    options: {
      hasComment: "Has comment",
      noComment: "No comment",
      unableToFindInstallCode: "Unable to obtain Install Code",
    },
    value: null,
    expandable: true,
  },
  asnDate: {
    type: FilterType.DATE_RANGE,
    label: "ASN Date",
    value: { from: null, to: null },
    expandable: true,
  },
  requestedDate: {
    type: FilterType.DATE_RANGE,
    label: "Requested Date",
    value: { from: null, to: null },
    expandable: true,
  },
  lastDateChecked: {
    type: FilterType.DATE_RANGE,
    label: "Last Date Checked",
    value: { from: null, to: null },
    expandable: true,
  },
  createdAt: {
    type: FilterType.DATE_RANGE,
    label: "Created At",
    value: { from: null, to: null },
    expandable: true,
  },
}

export const topFilters: {
  name: string
  filterName?: string
  label: string
  type: SoRadioCardChartType
}[] = [
  {
    name: "installCodesCount",
    filterName: EInstallCodeStatus.HAS_INSTALL_CODE,
    label: "Install Codes",
    type: "normal",
  },
  {
    name: "missingInstallCodesCount",
    filterName: EInstallCodeStatus.MISSING_INSTALL_CODE,
    label: "Missing Install Codes",
    type: "critical",
  },
  {
    name: "missingAsnCount",
    filterName: EInstallCodeStatus.MISSING_ASN,
    label: "Missing ASNs",
    type: "critical",
  },
  {
    name: "expiringAsnCount",
    filterName: EInstallCodeStatus.EXPIRING_ASN,
    label: "Expiring ASNs",
    type: "critical",
  },
]
